import {ActionReducerMapBuilder} from '@reduxjs/toolkit';
import {TimeslotsState} from '../stateTypes';
import {actions} from '../actions';
import {reservationCountQueryForWorkday, reservationCountQueryKey} from '../utils';

export const extendWithReservationCountReducers = (builder: ActionReducerMapBuilder<TimeslotsState>) => {
  builder
    .addCase(actions.fetchWorkspaceReservationCountsForWorkday.pending, (state, action) => {
      const key = reservationCountQueryKey(reservationCountQueryForWorkday(action.meta.arg.workday));

      state.workspaceReservationCounts[key] = {
        status: 'pending',
        data: state.workspaceReservationCounts[key]?.data,
        requestId: action.meta.requestId,
      };
    })
    .addCase(actions.fetchWorkspaceReservationCountsForWorkday.fulfilled, (state, action) => {
      const key = reservationCountQueryKey(reservationCountQueryForWorkday(action.meta.arg.workday));

      // Note: if a node is not included in this response, there are no reservations and the availability
      //       count equals the capacity (which you have to then get someplace else)
      state.workspaceReservationCounts[key] = {
        status: 'fulfilled',
        data: {
          resolvedAtTimestamp: Date.now(),
          countByNodeId: Object.fromEntries(action.payload.map((a) => [a.nodeId, a])),
        },
      };
    })
    .addCase(actions.fetchWorkspaceReservationCountsForWorkday.rejected, (state, action) => {
      const key = reservationCountQueryKey(reservationCountQueryForWorkday(action.meta.arg.workday));

      state.workspaceReservationCounts[key] = {
        status: 'rejected',
        data: null,
        errorMessage: action.error.message ?? 'Failed to load availabile count',
      };
    });
};
